import * as React from 'react';
import React__default, { useRef, useState, useEffect } from 'react';

var classnames$1 = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames$1));

var classnames = classnames$1.exports;

/* This file is generated, changes will get overwritten */
const SvgChevronRight24 = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", "aria-label": "Chevron Right", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M17 12a.75.75 0 0 1-.228.539l-8 7.75a.75.75 0 0 1-1.044-1.078L15.172 12 7.728 4.789A.75.75 0 0 1 8.772 3.71l8 7.75A.75.75 0 0 1 17 12", clipRule: "evenodd" })));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".slide-to-confirm-module_button__wEYeF {\n  align-items: center;\n  border-radius: 2px;\n  display: flex;\n  font-family: benton-sans, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  justify-content: center;\n  letter-spacing: 0.25px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n  height: 48px;\n  background: #00253e;\n  color: #ffffff;\n  position: relative;\n  z-index: 0;\n  border: none;\n}\n.slide-to-confirm-module_button__wEYeF:disabled {\n  background: #99a8b2;\n}\n.slide-to-confirm-module_buttonContent__UhTu8 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 16px 0 48px;\n}\n.slide-to-confirm-module_draggable__DeDxV {\n  position: absolute;\n  width: 50px;\n  height: 34px;\n  z-index: 1;\n}\n.slide-to-confirm-module_draggable__DeDxV::before {\n  display: block;\n  content: '';\n  background: #ffffff;\n  border-radius: 50%;\n  width: 34px;\n  height: 34px;\n  margin: 0 8px;\n}\n.slide-to-confirm-module_draggableIcon__79iHm {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #00253e;\n}\n.slide-to-confirm-module_sliding__uWj99 {\n  opacity: 0.5;\n  transition: opacity 0.5s ease;\n}\n.slide-to-confirm-module_returning__72wOb {\n  transition: all 0.5s ease;\n}\n";
var styles = {"button":"slide-to-confirm-module_button__wEYeF","buttonContent":"slide-to-confirm-module_buttonContent__UhTu8","draggable":"slide-to-confirm-module_draggable__DeDxV","draggableIcon":"slide-to-confirm-module_draggableIcon__79iHm","sliding":"slide-to-confirm-module_sliding__uWj99","returning":"slide-to-confirm-module_returning__72wOb"};
styleInject(css_248z,{"insertAt":"top"});

const Button = ({ id, className, onSlide, disabled = false, children, onSlideStart, onSlideCancel, }) => {
    const buttonRef = useRef(null);
    const draggableRef = useRef(null);
    const [dragPos, setDragPos] = useState(0);
    const [dragEndActivated, setDragEndActivated] = useState(false);
    const [dragStarted, setDragStarted] = useState(false);
    const onDragEnd = () => {
        setDragPos(0);
        setDragEndActivated(false);
        setDragStarted(false);
        onSlideCancel && onSlideCancel();
    };
    const onDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (dragEndActivated) {
            // Prevent user from holding the draggable triggering multiple activations
            return;
        }
        if (!dragStarted) {
            onSlideStart && onSlideStart();
            setDragStarted(true);
        }
        const buttonBox = buttonRef?.current?.getBoundingClientRect();
        const draggableBox = draggableRef?.current?.getBoundingClientRect();
        if (buttonBox && draggableBox) {
            const newPos = e.targetTouches?.[0]?.pageX - buttonBox.left;
            if (newPos >= 0 && newPos <= buttonBox.width - draggableBox.width) {
                setDragPos(newPos);
            }
            else if (newPos < 0) {
                setDragPos(0);
            }
            else if (newPos > buttonBox.width - draggableBox.width) {
                setDragPos(buttonBox.width - draggableBox.width);
                setDragEndActivated(true);
            }
        }
    };
    useEffect(() => {
        if (dragEndActivated) {
            setDragPos(0);
            onSlide();
        }
    }, [dragEndActivated]);
    return (React__default.createElement("button", { ref: buttonRef, id: id, className: classnames(className, styles.button), "aria-disabled": disabled, disabled: disabled },
        React__default.createElement("span", { className: classnames({
                [styles.draggable]: true,
                [styles.returning]: dragPos === 0,
            }), ref: draggableRef, style: { left: dragPos }, onTouchMove: onDrag, onTouchEnd: onDragEnd },
            React__default.createElement(SvgChevronRight24, { className: styles.draggableIcon })),
        React__default.createElement("span", { className: classnames(styles.buttonContent, { [styles.sliding]: dragPos > 0 }) }, children)));
};

export { Button };
//# sourceMappingURL=index.es.js.map
